import { Flag, Loader2 } from 'lucide-react';

import { Heading, Subheading } from '@/components/ui/catalyst/heading';
import { useGetTreatmentBarriersQuery } from '@/services/api/treatmentService';

import { BarrierType, barrierTypes } from '../constants';

interface FlaggedIssuesListProps {
  matterId: string;
  checkInId: string;
}

export const FlaggedIssuesList = ({
  matterId,
  checkInId,
}: FlaggedIssuesListProps) => {
  const { data: treatmentBarriers, isLoading } = useGetTreatmentBarriersQuery({
    matterId,
    discoveredInCheckInId: checkInId,
  });

  if (isLoading) {
    return (
      <div className="p-4 bg-white rounded-lg border shadow-sm">
        <Heading
          level={4}
          className="flex items-center gap-2 text-gray-800 mb-3"
        >
          <Flag className="h-5 w-5" />
          Loading issues...
          <Loader2 className="h-5 w-5 text-gray-500 animate-spin" />
        </Heading>
      </div>
    );
  }

  if (!treatmentBarriers || treatmentBarriers.length === 0) {
    return (
      <div className="p-4 bg-white rounded-lg border shadow-sm">
        <Subheading
          level={4}
          className="flex items-center gap-2 text-gray-800 "
        >
          <Flag className="h-5 w-5 text-gray-500" />
          No issues flagged for this check-in.
        </Subheading>
      </div>
    );
  }

  return (
    <div className="p-4 bg-white rounded-lg border shadow-sm">
      <Subheading level={4} className="flex items-center gap-2 text-gray-800 ">
        <Flag className="h-5 w-5 text-red-500" />
        Flagged Issues
      </Subheading>
      <div className="mt-4 pt-4 border-t">
        <ul className="mt-2 space-y-2">
          {treatmentBarriers.map((issue) => (
            <li
              key={issue.id}
              className="p-3 pr-2 bg-red-50 border border-red-200 rounded-md text-sm flex justify-between items-center"
            >
              <div>
                <strong className="font-semibold text-red-800">
                  {
                    barrierTypes.find(
                      (bt: BarrierType) => bt.value === issue.barrier_type,
                    )?.label
                  }
                  :{' '}
                </strong>
                <span className="text-red-700">{issue.notes}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
